import React from 'react'
import {Icon} from '@chakra-ui/react'

const PinIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.7748 0L13.3252 1.44959L14.6506 2.77491L9.60294 7.82253C7.91796 7.58891 6.04107 7.76547 4.24354 8.66423C3.44928 9.06136 2.71335 9.58703 2.05011 10.2503L1.32532 10.9751L6.45033 16.1001L0 22.5504L1.44959 24L7.89993 17.5497L13.0251 22.6748L13.7499 21.95C14.4131 21.2868 14.9388 20.5509 15.3359 19.7566C16.2347 17.9591 16.4112 16.0822 16.1776 14.3972L21.2252 9.3496L22.5504 10.6748L24 9.22517L14.7748 0ZM16.1002 4.22457L19.7757 7.90007L13.9402 13.7356L14.0809 14.2987C14.0932 14.3477 14.117 14.4671 14.1426 14.646C14.3309 15.9641 14.1955 17.4538 13.5025 18.8397C13.3501 19.1445 13.1727 19.4379 12.9687 19.719L4.28125 11.0316C4.56241 10.8276 4.85577 10.6502 5.16054 10.4978C6.54646 9.80482 8.03622 9.66939 9.35427 9.85768C9.53321 9.88324 9.6526 9.90712 9.70163 9.91938L10.2647 10.0601L16.1002 4.22457Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default PinIcon
